(function () {
  var root = document.querySelector('[data-sc-cart-drawer]');
  if (!root) return;

  document.body.appendChild(root);

  var config = {};
  try {
    var jsonEl = document.querySelector('[data-sc-cart-json]');
    config = jsonEl ? JSON.parse(jsonEl.textContent) : {};
  } catch (e) {
    config = {};
  }

  // Limit the Welcome Pack across variants and selling plans.
  var welcomePackHandle = 'daily-essentials-welcome-pack';
  var welcomePackVariantIds = config.welcomePackVariantIds || [];
  var cartAddQueue = Promise.resolve();
  function isWelcomePack(item) {
    return !!item && (item.handle === welcomePackHandle ||
      welcomePackVariantIds.some(function (id) {
        return Number(id) === Number(item.variant_id);
      }));
  }
  function welcomePackUpdates(cart) {
    var updates = {};
    var kept = false;
    (cart.items || []).forEach(function (item) {
      if (!isWelcomePack(item)) return;
      var quantity = kept ? 0 : 1;
      kept = true;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    return updates;
  }
  function limitWelcomePack(cart) {
    var updates = welcomePackUpdates(cart);
    if (!Object.keys(updates).length) return Promise.resolve(cart);
    return postCartUpdate(updates).then(function (nextCart) {
      if (document.querySelector('[data-sc-cart-page]')) window.location.reload();
      return nextCart;
    });
  }

  var upsellCatalog = [];
  try {
    var upsellJsonEl = document.querySelector('[data-sc-cart-upsell-json]');
    upsellCatalog = upsellJsonEl ? JSON.parse(upsellJsonEl.textContent) : [];
    if (!Array.isArray(upsellCatalog)) upsellCatalog = [];
  } catch (e) {
    upsellCatalog = [];
  }

  var sellingPlansByVariant = {};
  try {
    var plansJsonEl = document.querySelector('[data-sc-selling-plans-json]');
    sellingPlansByVariant = plansJsonEl ? JSON.parse(plansJsonEl.textContent) : {};
    if (!sellingPlansByVariant || typeof sellingPlansByVariant !== 'object') sellingPlansByVariant = {};
  } catch (e) {
    sellingPlansByVariant = {};
  }

  var itemsEl = root.querySelector('[data-sc-cart-items]');
  var emptyEl = root.querySelector('[data-sc-cart-empty]');
  var countEl = root.querySelector('[data-sc-cart-count]');
  var subtotalEl = root.querySelector('[data-sc-cart-subtotal]');
  var headerCounts = document.querySelectorAll('[data-sc-cart-count-badge]');
  var upsellRoot = root.querySelector('[data-sc-cart-upsell]');
  var rewardsRoot = root.querySelector('[data-sc-cart-rewards]');
  var footerEl = root.querySelector('[data-sc-cart-footer]');
  var savePercent = config.savePercent || 25;
  var giftConfig = config.gift || {};
  var giftProductId = giftConfig.productId || null;
  var giftVariantId = giftConfig.variantId || null;
  var qualifyingIds = (giftConfig.qualifyingIds || []).map(function (id) {
    return Number(id);
  });
  var giftSyncing = false;
  var currency = config.currency || 'SGD';
  var minusSrc = config.minusSrc || '';
  var plusSrc = config.plusSrc || '';
  var chevronSrc = config.chevronSrc || '';
  var upsellIndex = 0;
  var upsellTrack = upsellRoot ? upsellRoot.querySelector('[data-upsell-track]') : null;
  var upsellViewport = upsellRoot ? upsellRoot.querySelector('.sc-cart-upsell__viewport') : null;
  var upsellPrev = upsellRoot ? upsellRoot.querySelector('[data-upsell-prev]') : null;
  var upsellNext = upsellRoot ? upsellRoot.querySelector('[data-upsell-next]') : null;

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:currency, minimumFractionDigits:2, maximumFractionDigits:2}).format(Number(cents) / 100);
  }

  function moneyPlain(cents) {
    return money(cents);
  }

  function isWelcomeBox(item) {
    return !!(item && item.properties && item.properties._welcome_pack === 'true');
  }

  function isWelcomeComponent(item) {
    return isWelcomeBox(item) || !!(item && item.properties && item.properties._welcome_bottle === 'true');
  }

  function welcomeRemovalUpdates(cart, packId) {
    var updates = {};
    if (!packId) return updates;
    (cart.items || []).forEach(function (item) {
      if (isWelcomeComponent(item) && item.properties._welcome_pack_id === packId) updates[item.key] = 0;
    });
    return updates;
  }

  function isSubscription(item) {
    if (item.selling_plan_allocation) return true;
    var props = item.properties || {};
    var option = (props['Purchase option'] || props.Purchase || '').toString().toLowerCase();
    if (option.indexOf('one time') !== -1 || option.indexOf('onetime') !== -1) return false;
    return option.indexOf('subscribe') !== -1;
  }

  function isGiftItem(item) {
    if (!item) return false;
    if (giftProductId && Number(item.product_id) === Number(giftProductId)) return true;
    var props = item.properties || {};
    return props._subscription_gift === 'true' || props['_subscription_gift'] === 'true';
  }

  var GIFT_CHECKOUT_NOTE =
    'Not included in your first deliveries. You’ll receive it when you reach the 3rd month of your subscription, as long as your subscription remains active.';

  function giftLineProperties() {
    var props = { _subscription_gift: 'true' };
    // Checkout always prints "label: value", so the sentence is the value.
    props['Reserved for Month 3'] = GIFT_CHECKOUT_NOTE;
    return props;
  }

  function giftNeedsCheckoutNoteUpdate(item) {
    if (!item) return true;
    var props = item.properties || {};
    if (props['Free gift'] != null) return true;
    if (Object.prototype.hasOwnProperty.call(props, GIFT_CHECKOUT_NOTE)) return true;
    if (props['Reserved for Month 3'] !== GIFT_CHECKOUT_NOTE) return true;
    return false;
  }

  function isQualifyingSubscription(item) {
    if (!item || isGiftItem(item) || !isSubscription(item)) return false;
    if (!qualifyingIds.length) return false;
    return qualifyingIds.indexOf(Number(item.product_id)) !== -1;
  }

  function subscriptionPlanLabel(item) {
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      return 'Subscribe and Save: ' + item.selling_plan_allocation.selling_plan.name;
    }
    var delivery = item.properties && item.properties.Delivery
      ? item.properties.Delivery.replace(/\(.*\)/, '').trim()
      : '4 Weeks';
    return 'Subscribe and Save: Delivery Every ' + delivery;
  }

  function infoIcon() {
    return (
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
      '<circle cx="7" cy="7" r="6.25" stroke="currentColor" stroke-width="1.2"/>' +
      '<path d="M7 6.2V10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
      '<circle cx="7" cy="4.2" r="0.7" fill="currentColor"/>' +
      '</svg>'
    );
  }

  var planCacheByHandle = {};
  var planFetchTried = {};

  function getPlansForVariant(variantId) {
    if (variantId == null) return [];
    return sellingPlansByVariant[String(variantId)] || sellingPlansByVariant[variantId] || [];
  }

  function storePlans(variantId, handle, plans) {
    if (!plans || !plans.length) return plans || [];
    if (variantId != null) sellingPlansByVariant[String(variantId)] = plans;
    if (handle) planCacheByHandle[handle] = plans;
    return plans;
  }

  function plansFromProductJson(product) {
    var plans = [];
    var groups = (product && product.selling_plan_groups) || [];
    groups.forEach(function (group) {
      (group.selling_plans || []).forEach(function (sp) {
        if (!sp || sp.id == null) return;
        plans.push({
          id: sp.id,
          name: sp.name || '',
          discount: planDiscount(sp),
          price_adjustments: sp.price_adjustments || []
        });
      });
    });
    return plans;
  }

  function loadPlans(handle, variantId) {
    var cached = getPlansForVariant(variantId);
    if (cached.length) return Promise.resolve(cached);
    if (handle && planCacheByHandle[handle] && planCacheByHandle[handle].length) {
      return Promise.resolve(storePlans(variantId, handle, planCacheByHandle[handle]));
    }
    if (!handle) return Promise.resolve([]);

    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(function (product) {
        planFetchTried[handle] = true;
        return storePlans(variantId, handle, plansFromProductJson(product));
      })
      .catch(function () {
        planFetchTried[handle] = true;
        return [];
      });
  }

  function currentSellingPlanId(item) {
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      return item.selling_plan_allocation.selling_plan.id;
    }
    return null;
  }

  function sellingPlanId(item) {
    if (!item) return 0;
    var allocation = item.selling_plan_allocation;
    if (allocation) {
      if (allocation.selling_plan && allocation.selling_plan.id != null) {
        return Number(allocation.selling_plan.id);
      }
      if (allocation.selling_plan_id != null) return Number(allocation.selling_plan_id);
    }
    if (item.selling_plan_id != null) return Number(item.selling_plan_id);
    return Number(currentSellingPlanId(item) || 0);
  }

  function lineMatchKey(item) {
    return String(item.variant_id) + ':' + sellingPlanId(item) + ':' + welcomeIdentity(item.properties);
  }

  function percentFromText(text) {
    var match = String(text || '').match(/(\d+)\s*%/);
    return match ? Number(match[1]) : null;
  }

  function planDiscount(plan) {
    if (!plan) return null;
    if (plan.discount != null && plan.discount !== '') return Number(plan.discount);
    var adjustments = plan.price_adjustments || [];
    if (adjustments.length) {
      var adj = adjustments[0];
      if (adj && String(adj.value_type) === 'percentage' && adj.value != null) {
        return Number(adj.value);
      }
    }
    return percentFromText(plan.name);
  }

  function subscriptionSavePercent(item) {
    var allocation = item && item.selling_plan_allocation;
    var plan = allocation && allocation.selling_plan;
    var fromPlan = planDiscount(plan);
    if (fromPlan) return Math.round(fromPlan);
    if (allocation && Number(allocation.compare_at_price) > 0 && allocation.price != null) {
      var pct = Math.round((1 - Number(allocation.price) / Number(allocation.compare_at_price)) * 100);
      if (pct > 0 && pct < 100) return pct;
    }
    var matched = findPlan(getPlansForVariant(item && item.variant_id), currentSellingPlanId(item));
    var fromMatched = planDiscount(matched);
    if (fromMatched) return Math.round(fromMatched);
    return savePercent;
  }

  function firstPlanSavePercent(plans) {
    var fromPlan = planDiscount(plans && plans[0]);
    if (fromPlan) return Math.round(fromPlan);
    return savePercent;
  }

  function findPlan(plans, planId) {
    for (var i = 0; i < plans.length; i += 1) {
      if (String(plans[i].id) === String(planId)) return plans[i];
    }
    return null;
  }

  function lineQuantity(itemEl) {
    return parseInt(itemEl.getAttribute('data-qty'), 10)
      || parseInt((itemEl.querySelector('.sc-cart-item__qty-value') || {}).textContent, 10)
      || 1;
  }

  function itemHtml(item, index) {
    var image = item.featured_image
      ? item.featured_image.url
      : item.image || '';
    var subscribed = isSubscription(item);
    var welcomeBox = isWelcomeBox(item);
    var welcomeLocked = isWelcomeComponent(item);
    var plans = getPlansForVariant(item.variant_id);
    var currentPlanId = currentSellingPlanId(item);
    var planLabel = subscribed ? subscriptionPlanLabel(item) : 'One Time';
    var allocation = item.selling_plan_allocation || null;
    // Shopify's selling-plan price excludes additional promotional discounts.
    var linePrice = item._scDisplayLinePrice != null ? item._scDisplayLinePrice : item.final_line_price;
    if (linePrice == null) linePrice = Number(item.final_price) * item.quantity;
    var displayPrice = Number(linePrice) / Math.max(1, item.quantity);
    var comparePrice = allocation && allocation.compare_at_price
      ? allocation.compare_at_price
      : item.original_price;
    var showCompare = comparePrice > displayPrice;
    var savedAmount = Math.max(0, Math.round(comparePrice * item.quantity - linePrice));

    var html = '<article class="sc-cart-item' + (isGiftItem(item) ? ' sc-cart-item--gift' : '') + '" data-key="' + escapeHtml(item.key) + '" data-line="' + (index + 1) + '" data-welcome-locked="' + (welcomeLocked ? 'true' : 'false') + '" data-variant-id="' + item.variant_id + '" data-qty="' + item.quantity + '" data-handle="' + escapeHtml(item.handle || '') + '" data-selling-plan="' + (currentPlanId || 0) + '">';
    html += '<div class="sc-cart-item__media">';
    if (image) html += '<img src="' + image + '" alt="">';
    html += '</div>';
    html += '<div class="sc-cart-item__info">';
    html += '<h3 class="sc-cart-item__title">' + escapeHtml(item.product_title) + (item.variant_title && item.variant_title !== 'Default Title' ? ' - ' + escapeHtml(item.variant_title) : '') + '</h3>';

    if (item.properties && item.properties._welcome_bottle === 'true') {
      html += '<div class="sc-cart-item__plan">First delivery only</div>';
      html += '<div class="sc-cart-item__prices"><span class="sc-cart-item__price">' + (Number(displayPrice) === 0 ? 'Free' : money(displayPrice)) + '</span></div>';
      html += '<div class="sc-cart-item__actions">Quantity: 1</div>';
      html += '</div></article>';
      return html;
    }

    if (isGiftItem(item)) {
      html += '<div class="sc-cart-item__plan sc-cart-item__plan--gift"><span>Reserved for Month 3</span></div>';
      html += '<div class="sc-cart-item__prices">';
      html += '<span class="sc-cart-item__price">' + (Number(displayPrice) === 0 ? 'Free' : money(displayPrice)) + '</span>';
      html += '</div>';
      html += '<div class="sc-cart-item__save">' + infoIcon() + '<span>Not included in your first deliveries. You’ll receive it when you reach the 3rd month of your subscription, as long as your subscription remains active.</span></div>';
      html += '</div></article>';
      return html;
    }

    if (item.properties && item.properties._welcome_pack === 'true') {
      html += '<div class="sc-cart-item__plan">Welcome pack box</div>';
    }

    if (subscribed && plans.length && !welcomeBox) {
      html += '<label class="sc-cart-item__plan sc-cart-item__plan--sub">';
      html += '<select class="sc-cart-item__plan-select" data-plan-change aria-label="Subscription plan">';
      plans.forEach(function (plan) {
        var selected = String(plan.id) === String(currentPlanId) ? ' selected' : '';
        html += '<option value="' + plan.id + '"' + selected + '>Subscribe and Save: ' + escapeHtml(plan.name) + '</option>';
      });
      html += '</select>';
      if (chevronSrc) {
        html += '<img class="sc-cart-item__plan-chevron" src="' + chevronSrc + '" alt="" width="12" height="6">';
      }
      html += '</label>';
    } else {
      html += '<div class="sc-cart-item__plan' + (subscribed ? ' sc-cart-item__plan--sub' : '') + '">';
      html += '<span>' + escapeHtml(planLabel) + '</span>';
      if (subscribed && chevronSrc && !welcomeBox) {
        html += '<img class="sc-cart-item__plan-chevron" src="' + chevronSrc + '" alt="" width="12" height="6">';
      }
      html += '</div>';
    }

    html += '<div class="sc-cart-item__prices">';
    if (showCompare) {
      html += '<span class="sc-cart-item__compare">' + moneyPlain(comparePrice) + '</span>';
    }
    html += '<span class="sc-cart-item__price">' + money(displayPrice) + '</span>';
    html += '</div>';

    if (savedAmount > 0) {
      html += '<div class="sc-cart-item__save">' + infoIcon() + '<span>You save ' + money(savedAmount) + ' on this order.</span></div>';
    }
    if (!subscribed) {
      var firstPlan = plans[0] || null;
      html += '<button type="button" class="sc-cart-item__upsell" data-convert-sub';
      if (firstPlan) {
        html += ' data-plan-id="' + firstPlan.id + '" data-plan-name="' + escapeHtml(firstPlan.name) + '"';
      }
      html += '>';
      html += infoIcon() + '<span>Subscribe to get ' + firstPlanSavePercent(plans) + '% off</span>';
      html += '</button>';
    }

    html += '<div class="sc-cart-item__actions">';
    html += '<span class="sc-cart-item__qty-label">Quantity</span>';
    html += '<div class="sc-cart-item__actions-right">';
    if (isWelcomePack(item) || welcomeBox) {
      html += '<span class="sc-cart-item__qty-value">' + item.quantity + '</span>';
    } else {
    html += '<div class="sc-cart-item__qty">';
    html += '<button type="button" class="sc-cart-item__qty-btn" data-qty-change="-1" aria-label="Decrease quantity"><img src="' + minusSrc + '" alt=""></button>';
    html += '<span class="sc-cart-item__qty-value">' + item.quantity + '</span>';
    html += '<button type="button" class="sc-cart-item__qty-btn" data-qty-change="1" aria-label="Increase quantity"><img src="' + plusSrc + '" alt=""></button>';
    html += '</div>';
    }
    if (welcomeBox) {
      var firstWelcomeBox = ((lastCart && lastCart.items) || []).find(isWelcomeBox);
      if (firstWelcomeBox && firstWelcomeBox.key === item.key) {
        html += '<button type="button" class="sc-cart-item__remove" data-remove-welcome-pack>Remove welcome pack</button>';
      }
    } else {
      html += '<button type="button" class="sc-cart-item__remove" data-remove>Remove</button>';
    }
    html += '</div></div>';

    html += '</div>';
    html += '</article>';
    return html;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function upsellSlideHtml(product) {
    var html = '<div class="sc-cart-upsell__slide" data-upsell-slide data-product-id="' + product.id + '">';
    html += '<div class="sc-cart-upsell__media">';
    if (product.image) {
      html += '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
    }
    html += '</div>';
    html += '<div class="sc-cart-upsell__copy">';
    html += '<p class="sc-cart-upsell__title">' + escapeHtml(product.title) + '</p>';
    html += '<p class="sc-cart-upsell__price">' + money(product.price) + '</p>';
    html += '</div>';
    html += '<button type="button" class="sc-cart-upsell__add" data-upsell-add="' + product.variantId + '">Add to Cart</button>';
    html += '</div>';
    return html;
  }

  function getUpsellSlides() {
    if (!upsellRoot) return [];
    return Array.prototype.slice.call(upsellRoot.querySelectorAll('[data-upsell-slide]'));
  }

  function showUpsellSlide(i) {
    var slides = getUpsellSlides();
    if (!slides.length || !upsellTrack) return;
    upsellIndex = ((i % slides.length) + slides.length) % slides.length;
    upsellTrack.style.transition = 'transform 0.35s ease';
    upsellTrack.style.transform = 'translateX(-' + upsellIndex * 100 + '%)';
    if (upsellPrev) upsellPrev.disabled = slides.length < 2;
    if (upsellNext) upsellNext.disabled = slides.length < 2;
  }

  function updateUpsell(cart) {
    if (!upsellRoot || !upsellTrack) return;

    var inCart = {};
    (cart.items || []).forEach(function (item) {
      if (item.product_id) inCart[item.product_id] = true;
    });

    var available = upsellCatalog.filter(function (product) {
      return product && product.id && !inCart[product.id] && Number(product.id) !== Number(giftProductId);
    });

    if (!(cart.items || []).length || !available.length) {
      upsellRoot.hidden = true;
      upsellTrack.innerHTML = '';
      return;
    }

    upsellTrack.innerHTML = available.map(upsellSlideHtml).join('');
    upsellRoot.hidden = false;
    showUpsellSlide(0);
  }

  function displayCartItems(items) {
    var grouped = [];
    var indexByKey = {};
    (items || []).forEach(function (item, index) {
      if (isGiftItem(item)) {
        grouped.push({ item: item, line: index + 1 });
        return;
      }
      var k = lineMatchKey(item);
      if (indexByKey[k] == null) {
        var copy = {};
        Object.keys(item).forEach(function (key) {
          copy[key] = item[key];
        });
        copy.quantity = item.quantity;
        indexByKey[k] = grouped.length;
        grouped.push({ item: copy, line: index + 1 });
      } else {
        var combined = grouped[indexByKey[k]].item;
        combined.quantity += item.quantity;
        combined.final_line_price = Number(combined.final_line_price) + Number(item.final_line_price);
        if (combined._scDisplayLinePrice != null && item._scDisplayLinePrice != null) {
          combined._scDisplayLinePrice += item._scDisplayLinePrice;
        }
      }
    });
    grouped.sort(function (a, b) {
      return (isGiftItem(a.item) ? 1 : 0) - (isGiftItem(b.item) ? 1 : 0);
    });
    return grouped;
  }

  function packCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isGiftItem(item)) return sum;
      return sum + (item.quantity || 0);
    }, 0);
  }

  function updateRewards(cart) {
    if (!rewardsRoot) return;
    var packs = packCount(cart);
    var steps = [2, 3, 4];
    var reached = 0;
    steps.forEach(function (step, i) {
      if (packs >= step) reached = i + 1;
    });
    rewardsRoot.querySelectorAll('[data-reward-badge]').forEach(function (el, i) {
      el.classList.toggle('is-active', i < reached);
    });
    rewardsRoot.querySelectorAll('[data-reward-dot]').forEach(function (el, i) {
      el.classList.toggle('is-active', i < reached);
    });
    var fill = rewardsRoot.querySelector('[data-reward-fill]');
    if (fill) {
      fill.style.width = reached <= 1 ? (reached === 1 ? '0%' : '0%') : ((reached - 1) / 2) * 100 + '%';
      if (reached === 1) fill.style.width = '0%';
      if (reached === 2) fill.style.width = '50%';
      if (reached >= 3) fill.style.width = '100%';
    }
  }

  function updateHeaderCount(count) {
    headerCounts.forEach(function (el) {
      if (count > 0) {
        el.hidden = false;
        el.textContent = count;
      } else {
        el.hidden = true;
      }
    });
  }

  var lastCart = null;
  var prefetchingPlans = false;
  var qtyUpdating = false;

  function prefetchMissingPlans(cart) {
    if (prefetchingPlans) return;
    var missing = (cart.items || []).filter(function (item) {
      return item.handle && !getPlansForVariant(item.variant_id).length && !planFetchTried[item.handle];
    });
    if (!missing.length) return;
    prefetchingPlans = true;
    Promise.all(
      missing.map(function (item) {
        return loadPlans(item.handle, item.variant_id);
      })
    )
      .then(function () {
        prefetchingPlans = false;
        if (lastCart) render(lastCart);
      })
      .catch(function () {
        prefetchingPlans = false;
      });
  }

  function render(cart) {
    if (!cart || !Array.isArray(cart.items)) return cart;
    lastCart = cart;

    var items = cart.items;
    if (countEl) countEl.textContent = cart.item_count || 0;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    updateHeaderCount(cart.item_count || 0);
    renderOrderDiscountSummary(cart);

    if (!items.length) {
      if (itemsEl) itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (rewardsRoot) rewardsRoot.hidden = true;
      if (footerEl) footerEl.hidden = true;
    } else {
      if (emptyEl) emptyEl.hidden = true;
      if (itemsEl) itemsEl.innerHTML = displayCartItems(items).map(function (entry) {
        return itemHtml(entry.item, entry.line - 1);
      }).join('');
      if (rewardsRoot) rewardsRoot.hidden = false;
      if (footerEl) footerEl.hidden = false;
    }
    updateUpsell(cart);
    updateRewards(cart);
    prefetchMissingPlans(cart);
    return cart;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function postCartChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data || !Array.isArray(data.items)) {
          var message = (data && (data.description || data.message)) || 'Unable to update cart.';
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function postCartUpdate(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data || !Array.isArray(data.items)) {
          var message = (data && (data.description || data.message)) || 'Unable to update cart.';
          throw new Error(message);
        }
        return data;
      });
    });
  }

  function lineProperties(item) {
    var src = (item && item.properties) || {};
    var out = {};
    if (src['Purchase option']) out['Purchase option'] = src['Purchase option'];
    if (src.Delivery) out.Delivery = src.Delivery;
    if (src._welcome_pack) out._welcome_pack = src._welcome_pack;
    if (src._welcome_pack_id) out._welcome_pack_id = src._welcome_pack_id;
    if (src._welcome_bottle) out._welcome_bottle = src._welcome_bottle;
    if (src['Welcome gift']) out['Welcome gift'] = src['Welcome gift'];
    return out;
  }

  function welcomeIdentity(properties) {
    var props = properties || {};
    return (props._welcome_pack || props._welcome_bottle) ?
      String(props._welcome_pack_id || 'legacy') + ':' + (props._welcome_bottle ? 'bottle' : 'box') : '';
  }

  function matchingLines(cart, variantId, planId, properties) {
    planId = Number(planId || 0);
    return (cart.items || []).filter(function (item) {
      if (isGiftItem(item)) return false;
      if (Number(item.variant_id) !== Number(variantId)) return false;
      return sellingPlanId(item) === planId && welcomeIdentity(item.properties) === welcomeIdentity(properties);
    });
  }

  function addLine(variantId, quantity, planId, properties) {
    var body = { id: Number(variantId), quantity: Number(quantity) || 1 };
    if (planId) body.selling_plan = Number(planId);
    if (properties && Object.keys(properties).length) body.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error((data && (data.description || data.message)) || 'Unable to add to cart.');
        }
        return data;
      });
    });
  }

  function lineQtyTotal(items) {
    return (items || []).reduce(function (sum, item) {
      return sum + (Number(item.quantity) || 0);
    }, 0);
  }

  function replaceMatchingLines(variantId, planId, quantity, properties) {
    var qty = Math.max(0, Number(quantity) || 0);
    var props = lineProperties({ properties: properties || {} });
    return fetchCart().then(function (cart) {
      var matches = matchingLines(cart, variantId, planId, properties);

      if (!matches.length) {
        if (qty <= 0) return cart;
        return addLine(variantId, qty, planId, props).then(fetchCart);
      }

      var updates = {};
      updates[matches[0].key] = qty;
      matches.slice(1).forEach(function (item) {
        updates[item.key] = 0;
      });

      return postCartUpdate(updates).then(function (updated) {
        var still = matchingLines(updated, variantId, planId, props);
        if (qty === 0 && !still.length) return updated;
        if (still.length === 1 && Number(still[0].quantity) === qty) return updated;
        if (still.length > 1) {
          var collapse = {};
          collapse[still[0].key] = qty;
          still.slice(1).forEach(function (item) {
            collapse[item.key] = 0;
          });
          return postCartUpdate(collapse);
        }
        if (still.length === 1 && Number(still[0].quantity) !== qty) {
          var retry = {};
          retry[still[0].key] = qty;
          return postCartUpdate(retry);
        }
        return updated;
      });
    });
  }

  function ensureGift(cart) {
    if (!giftProductId || !giftVariantId || !qualifyingIds.length) return Promise.resolve(cart);
    if (giftSyncing) return Promise.resolve(cart);

    // Welcome subscriptions receive the same Month 3 reservation as normal subscriptions.
    var want = (cart.items || []).some(isQualifyingSubscription);
    var gifts = (cart.items || []).filter(isGiftItem);
    var primaryGift = gifts[0];
    var giftOk =
      want &&
      gifts.length === 1 &&
      Number(primaryGift.quantity) === 1 &&
      !giftNeedsCheckoutNoteUpdate(primaryGift);

    if (giftOk) return Promise.resolve(cart);
    if (!want && !gifts.length) return Promise.resolve(cart);

    giftSyncing = true;
    var chain = Promise.resolve();

    if (want) {
      if (!gifts.length) {
        chain = chain.then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: Number(giftVariantId),
              quantity: 1,
              properties: giftLineProperties()
            })
          }).then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Unable to add gift.');
              return data;
            });
          });
        });
      } else {
        chain = chain.then(function () {
          return postCartChange({
            id: primaryGift.key,
            quantity: 1,
            properties: giftLineProperties()
          });
        });
        gifts.slice(1).forEach(function (giftItem) {
          chain = chain.then(function () {
            return postCartChange({ id: giftItem.key, quantity: 0 });
          });
        });
      }
    } else {
      gifts.forEach(function (giftItem) {
        chain = chain.then(function () {
          return postCartChange({ id: giftItem.key, quantity: 0 });
        });
      });
    }

    return chain
      .then(fetchCart)
      .then(function (nextCart) {
        giftSyncing = false;
        if (document.querySelector('[data-sc-cart-page]')) {
          window.location.reload();
        }
        return nextCart;
      })
      .catch(function () {
        giftSyncing = false;
        return fetchCart();
      });
  }


  // Theme-level eligibility only. Native discount codes remain usable directly at checkout.
  var welcomeCodes = ['SC-TEST-WELCOME-780-K7Q', 'SC-TEST-BOTTLE-K7Q', 'WELCOME-PACK-KIT'];
  function ensureWelcomeBottle(cart) {
    var items = cart.items || [];
    var boxes = items.filter(function (item) {return item.properties && item.properties._welcome_pack === 'true';});
    var bottles = items.filter(function (item) {return item.properties && item.properties._welcome_bottle === 'true';});
    var packId = boxes.length && boxes[0].properties._welcome_pack_id;
    var planId = boxes.length && sellingPlanId(boxes[0]);
    var valid = !!packId && !!planId && boxes.every(function (item) {
      return item.properties._welcome_pack_id === packId &&
        [8342481305663, 8342481272895].indexOf(Number(item.product_id)) !== -1 &&
        sellingPlanId(item) === planId;
    }) && lineQtyTotal(boxes) === 2 && bottles.length === 1 &&
      bottles[0].properties._welcome_pack_id === packId &&
      Number(bottles[0].variant_id) === 44173995147327 &&
      !sellingPlanId(bottles[0]) && bottles[0].quantity === 1;
    var updates = {};
    if (!valid) bottles.forEach(function (bottle) {updates[bottle.key] = 0;});
    var existingCodes = (cart.discount_codes || []).map(function (discount) {return discount.code;});
    // Retire the extra first-order discount even for a complete existing welcome pack.
    var remainingCodes = existingCodes.filter(function (code) {
      var normalized = String(code).toUpperCase();
      if (normalized === 'SC-TEST-WELCOME-780-K7Q' || normalized === 'SC-TEST-BOTTLE-K7Q') return false;
      return valid || welcomeCodes.indexOf(normalized) === -1;
    });
    // Restore the welcome code if another cart or checkout action dropped it.
    var hasWelcomeCode = remainingCodes.some(function (code) {return String(code).toUpperCase() === 'WELCOME-PACK-KIT';});
    if (valid && !hasWelcomeCode) remainingCodes.push('WELCOME-PACK-KIT');
    var codesChanged = remainingCodes.join(',') !== existingCodes.join(',');
    var retryWelcomeCode = valid && (Number(bottles[0].final_line_price) !== 0 ||
      (cart.discount_codes || []).some(function (discount) {
        return String(discount.code).toUpperCase() === 'WELCOME-PACK-KIT' && discount.applicable === false;
      }));
    if (!Object.keys(updates).length && !codesChanged && !retryWelcomeCode) return Promise.resolve(cart);
    var body = {updates:updates};
    if (codesChanged || retryWelcomeCode) body.discount = remainingCodes.join(',');
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(route + 'cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (nextCart) {
        if (!res.ok || !nextCart || !Array.isArray(nextCart.items)) throw new Error('Please refresh your cart before checkout.');
        if (document.querySelector('[data-sc-cart-page]') && Object.keys(updates).length) window.location.reload();
        return nextCart;
      });
    });
  }

  // Liquid exposes each line's exact order-discount allocation. Never infer
  // eligibility from a promo URL or distribute a cart discount across products.
  function withDisplayPrices(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return Promise.resolve(cart);
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); }, 5000) : null;
    return fetch(route + '?section_id=sc-cart-prices', {
      credentials: 'same-origin', cache: 'no-store',
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart price display unavailable');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var element = doc.querySelector('[data-sc-cart-prices]');
      var prices = element && JSON.parse(element.textContent);
      if (!prices || prices.currency !== cart.currency || prices.total !== cart.total_price ||
          !Array.isArray(prices.items) || prices.items.length !== cart.items.length) return cart;
      var byKey = {};
      var sum = 0;
      prices.items.forEach(function (line) { byKey[line.key] = line; sum += line.line_price; });
      if (sum !== cart.total_price) return cart;
      var valid = cart.items.every(function (item) {
        var line = byKey[item.key];
        return line && line.quantity === item.quantity && Number.isFinite(line.line_price) && line.line_price >= 0;
      });
      if (!valid) return cart;
      cart.items.forEach(function (item) { item._scDisplayLinePrice = byKey[item.key].line_price; });
      cart._scDisplayPricesReady = true;
      return cart;
    }).catch(function () { return cart; }).then(function (result) {
      if (timeout) clearTimeout(timeout);
      return result;
    });
  }

  function renderOrderDiscountSummary(cart) {
    if (!subtotalEl || !subtotalEl.parentNode) return;
    var summary = root.querySelector('[data-sc-order-discount-summary]');
    if (!summary) {
      summary = document.createElement('div');
      summary.setAttribute('data-sc-order-discount-summary', '');
      summary.className = 'sc-cart-item__save';
      subtotalEl.parentNode.parentNode.insertBefore(summary, subtotalEl.parentNode);
    }
    var discounts = (cart.cart_level_discount_applications || []).filter(function (discount) {
      return Number(discount.total_allocated_amount) > 0;
    });
    summary.hidden = !discounts.length;
    summary.textContent = discounts.map(function (discount) {
      return (cart._scDisplayPricesReady ? 'Includes ' : 'Order discount: ') + discount.title +
        ' savings of ' + moneyPlain(discount.total_allocated_amount) + '.';
    }).join(' ');
  }

  function applyCart(cart) {
    return ensureWelcomeBottle(cart).then(limitWelcomePack).then(function (limitedCart) {
      return ensureGift(limitedCart).then(ensureWelcomeBottle).then(withDisplayPrices).then(function (nextCart) {
        render(nextCart);
        return nextCart;
      });
    });
  }

  function planIdFromEl(itemEl, key) {
    var planId = Number(itemEl.getAttribute('data-selling-plan') || 0);
    if (planId) return planId;
    if (lastCart && key) {
      for (var i = 0; i < (lastCart.items || []).length; i += 1) {
        if (lastCart.items[i].key === key) return sellingPlanId(lastCart.items[i]);
      }
    }
    return 0;
  }

  function addOrIncrement(detail) {
    var next = cartAddQueue.then(function () { return performAddOrIncrement(detail); });
    cartAddQueue = next.catch(function () {});
    return next;
  }
  function performAddOrIncrement(detail) {
    var variantId = Number(detail.id);
    var quantity = Number(detail.quantity) || 1;
    var planId = detail.selling_plan ? Number(detail.selling_plan) : 0;
    var properties = lineProperties({ properties: detail.properties || {} });
    return fetchCart().then(function (cart) {
      if (isWelcomePack({ variant_id: variantId })) {
        // A repeat click keeps the existing pack and its selection.
        if ((cart.items || []).some(isWelcomePack)) return cart;
        return addLine(variantId, 1, planId, properties).then(fetchCart);
      }
      var matches = matchingLines(cart, variantId, planId, properties);
      var current = matches.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
      return replaceMatchingLines(variantId, planId, current + quantity, properties);
    }).then(applyCart);
  }

  function refresh() {
    return fetchCart().then(applyCart);
  }

  window.scWelcomeRefreshCart = refresh;

  function changeLine(payload) {
    return postCartChange(payload)
      .then(applyCart)
      .catch(function (error) {
        return refresh().then(function () {
          throw error;
        });
      });
  }

  function lineHasSubscription(cart, variantId) {
    return (cart.items || []).some(function (item) {
      return Number(item.variant_id) === Number(variantId) && !!item.selling_plan_allocation;
    });
  }

  function applySellingPlan(itemEl, plan) {
    if (!itemEl || !plan || plan.id == null) return Promise.resolve();

    var key = itemEl.getAttribute('data-key');
    var variantId = Number(itemEl.getAttribute('data-variant-id'));
    var quantity = lineQuantity(itemEl);
    var planId = Number(plan.id);

    if (!key || !variantId || !planId) return Promise.resolve();

    return postCartChange({
      id: key,
      quantity: quantity,
      selling_plan: planId
    })
      .then(function (cart) {
        if (lineHasSubscription(cart, variantId)) return applyCart(cart);
        throw new Error('Subscription was not applied');
      })
      .catch(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            selling_plan: planId
          })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                throw new Error((data && (data.description || data.message)) || 'Unable to subscribe.');
              }
              return data;
            });
          })
          .then(function () {
            return postCartChange({ id: key, quantity: 0 });
          })
          .then(applyCart);
      });
  }

  function changePlanOnly(itemEl, plan) {
    if (!itemEl || !plan || plan.id == null) return Promise.resolve();

    var key = itemEl.getAttribute('data-key');
    var variantId = Number(itemEl.getAttribute('data-variant-id'));
    var quantity = lineQuantity(itemEl);
    var planId = Number(plan.id);
    if (!key || !planId) return Promise.resolve();

    return postCartChange({
      id: key,
      quantity: quantity,
      selling_plan: planId
    }).then(function (cart) {
      var items = cart.items || [];
      var oldItem = null;
      var hasNewPlanLine = false;

      items.forEach(function (item) {
        if (item.key === key) oldItem = item;
        if (
          item.key !== key &&
          Number(item.variant_id) === variantId &&
          Number(currentSellingPlanId(item)) === planId
        ) {
          hasNewPlanLine = true;
        }
      });

      var oldStillWrongPlan = oldItem && Number(currentSellingPlanId(oldItem)) !== planId;
      if (oldStillWrongPlan && hasNewPlanLine) {
        return postCartChange({ id: key, quantity: 0 }).then(applyCart);
      }
      return applyCart(cart);
    });
  }

  function convertItemToSubscription(itemEl) {
    var handle = itemEl.getAttribute('data-handle');
    var variantId = itemEl.getAttribute('data-variant-id');
    var convertBtn = itemEl.querySelector('[data-convert-sub]');
    var inlinePlan = null;
    if (convertBtn && convertBtn.getAttribute('data-plan-id')) {
      inlinePlan = {
        id: convertBtn.getAttribute('data-plan-id'),
        name: convertBtn.getAttribute('data-plan-name') || ''
      };
    }

    return loadPlans(handle, variantId).then(function (plans) {
      var plan = plans[0] || inlinePlan;
      if (!plan) throw new Error('No subscription plan available for this product.');
      return applySellingPlan(itemEl, plan);
    });
  }

  function openDrawer(options) {
    document.body.appendChild(root);
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (!root.classList.contains('is-open')) {
      root.classList.add('is-open');
      void root.offsetWidth;
      root.classList.add('is-visible');
    } else if (!root.classList.contains('is-visible')) {
      void root.offsetWidth;
      root.classList.add('is-visible');
    }
    if (!options || !options.skipRefresh) refresh();
  }

  function closeDrawer() {
    var panel = root.querySelector('.sc-cart-drawer__panel');
    root.classList.remove('is-visible');
    document.body.style.overflow = '';
    root.setAttribute('aria-hidden', 'true');

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      if (panel) panel.removeEventListener('transitionend', onEnd);
      root.classList.remove('is-open');
    }
    function onEnd(event) {
      if (event && event.target !== panel) return;
      finish();
    }
    if (panel) panel.addEventListener('transitionend', onEnd);
    setTimeout(finish, 420);
  }

  var welcomeCheckoutBusy = false;
  function validateWelcomeCheckout(event) {
    var target = event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-sc-cart-checkout]');
    var submitter = event.submitter;
    var checkoutForm = event.type === 'submit' && submitter && submitter.name === 'checkout';
    if (!target && !checkoutForm) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (welcomeCheckoutBusy) return;
    welcomeCheckoutBusy = true;
    cartAddQueue.then(refresh).then(function (cart) {
      if (!(cart.items || []).length) {welcomeCheckoutBusy = false; return;}
      var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var welcomeBottle = (cart.items || []).find(function (item) {
        return item.properties && item.properties._welcome_bottle === 'true';
      });
      var paidReservation = (cart.items || []).some(function (item) {
        return isGiftItem(item) && Number(item.final_line_price) !== 0;
      });
      if ((welcomeBottle && Number(welcomeBottle.final_line_price) !== 0) || paidReservation) {
        welcomeCheckoutBusy = false;
        window.alert('Your gift discount could not be applied. Please refresh your cart or contact us before checking out.');
        return;
      }
      // Shopify's discount link also carries the code into accelerated checkout.
      window.location.assign(welcomeBottle ?
        route + 'discount/WELCOME-PACK-KIT?redirect=' + encodeURIComponent(route + 'checkout') :
        route + 'checkout');
    }).catch(function () {
      welcomeCheckoutBusy = false;
      window.alert('We could not verify your cart. Please refresh before checking out.');
    });
  }
  document.addEventListener('click', validateWelcomeCheckout, true);
  document.addEventListener('submit', validateWelcomeCheckout, true);

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-sc-cart-open]');
    if (!openBtn) return;
    event.preventDefault();
    openDrawer();
  });

  root.querySelectorAll('[data-sc-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  root.addEventListener('click', function (event) {
    if (event.target === root) closeDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
  });

  if (itemsEl) {
    itemsEl.addEventListener('click', function (event) {
      var item = event.target.closest('.sc-cart-item');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var line = parseInt(item.getAttribute('data-line'), 10);
      var removeWelcomeBtn = event.target.closest('[data-remove-welcome-pack]');
      if (removeWelcomeBtn) {
        event.preventDefault();
        event.stopPropagation();
        removeWelcomeBtn.disabled = true;
        cartAddQueue = cartAddQueue.catch(function () {}).then(function () {
          return fetchCart().then(function (cart) {
            var source = cart.items.find(function (entry) {return entry.key === key;});
            var updates = welcomeRemovalUpdates(cart, source && source.properties && source.properties._welcome_pack_id);
            return Object.keys(updates).length ? postCartUpdate(updates) : cart;
          }).then(applyCart);
        }).catch(function () {return refresh();}).finally(function () {removeWelcomeBtn.disabled = false;});
        return;
      }
      if (item.getAttribute('data-welcome-locked') === 'true') return;
      var qtyBtn = event.target.closest('[data-qty-change]');
      var removeBtn = event.target.closest('[data-remove]');
      var convertBtn = event.target.closest('[data-convert-sub]');
      var currentEl = item.querySelector('.sc-cart-item__qty-value');
      var current = parseInt((item.getAttribute('data-qty') || (currentEl && currentEl.textContent) || '1'), 10) || 1;

      if (qtyBtn) {
        event.preventDefault();
        event.stopPropagation();
        if (item.getAttribute('data-handle') === welcomePackHandle) return;
        if (qtyUpdating) return;
        qtyUpdating = true;
        var delta = parseInt(qtyBtn.getAttribute('data-qty-change'), 10) || 0;
        var variantId = Number(item.getAttribute('data-variant-id'));
        var planId = planIdFromEl(item, key);
        fetchCart().then(function (cart) {
          var source = cart.items.find(function (line) {return line.key === key;});
          if (!source) return cart;
          var matches = matchingLines(cart, variantId, planId, source.properties);
          var currentTotal = lineQtyTotal(matches);
          var nextTotal = Math.max(0, currentTotal + delta);
          if (currentEl) currentEl.textContent = String(nextTotal);
          item.setAttribute('data-qty', String(nextTotal));
          return replaceMatchingLines(variantId, planId, nextTotal, lineProperties(matches[0]));
        })
          .then(applyCart)
          .catch(function () {
            return refresh();
          })
          .finally(function () {
            qtyUpdating = false;
          });
        return;
      }
      if (removeBtn) {
        var variantId = Number(item.getAttribute('data-variant-id'));
        var planId = planIdFromEl(item, key);
        fetchCart().then(function (cart) {
          var source = cart.items.find(function (line) {return line.key === key;});
          return source ? replaceMatchingLines(variantId, planId, 0, source.properties) : cart;
        }).then(applyCart);
        return;
      }
      if (convertBtn) {
        event.preventDefault();
        convertBtn.disabled = true;
        convertItemToSubscription(item)
          .catch(function () {})
          .finally(function () {
            convertBtn.disabled = false;
          });
        return;
      }
    });

    itemsEl.addEventListener('change', function (event) {
      var select = event.target.closest('[data-plan-change]');
      if (!select) return;
      var item = select.closest('.sc-cart-item');
      if (!item || item.getAttribute('data-welcome-locked') === 'true') return;
      var plans = getPlansForVariant(item.getAttribute('data-variant-id'));
      var plan = findPlan(plans, select.value);
      if (!plan) {
        plan = {
          id: select.value,
          name: (select.options[select.selectedIndex] && select.options[select.selectedIndex].textContent || '')
            .replace(/^Subscribe and Save:\s*/, '')
        };
      }
      select.disabled = true;
      changePlanOnly(item, plan)
        .catch(function () {})
        .finally(function () {
          select.disabled = false;
        });
    });
  }

  if (upsellRoot) {
    if (upsellPrev) {
      upsellPrev.addEventListener('click', function () {
        showUpsellSlide(upsellIndex - 1);
      });
    }
    if (upsellNext) {
      upsellNext.addEventListener('click', function () {
        showUpsellSlide(upsellIndex + 1);
      });
    }

    if (upsellViewport && upsellTrack) {
      var startX = 0;
      var dragging = false;

      upsellViewport.addEventListener('pointerdown', function (event) {
        if (event.target.closest('[data-upsell-add]')) return;
        if (getUpsellSlides().length < 2) return;
        dragging = true;
        startX = event.clientX;
        upsellTrack.style.transition = 'none';
        upsellViewport.setPointerCapture(event.pointerId);
      });

      upsellViewport.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var dx = event.clientX - startX;
        var width = upsellViewport.offsetWidth || 1;
        upsellTrack.style.transform = 'translateX(' + ((-upsellIndex * width) + dx) + 'px)';
      });

      function endDrag(event) {
        if (!dragging) return;
        dragging = false;
        var dx = event.clientX - startX;
        var width = upsellViewport.offsetWidth || 1;
        if (dx < -width * 0.2) showUpsellSlide(upsellIndex + 1);
        else if (dx > width * 0.2) showUpsellSlide(upsellIndex - 1);
        else showUpsellSlide(upsellIndex);
      }

      upsellViewport.addEventListener('pointerup', endDrag);
      upsellViewport.addEventListener('pointercancel', endDrag);
    }

    upsellRoot.addEventListener('click', function (event) {
      var addBtn = event.target.closest('[data-upsell-add]');
      if (!addBtn) return;
      var id = addBtn.getAttribute('data-upsell-add');
      addBtn.disabled = true;
      addOrIncrement({ id: id, quantity: 1 })
        .catch(function () { return refresh(); })
        .finally(function () { addBtn.disabled = false; });
    });
  }

  document.addEventListener('sc:cart:open', function (event) {
    openDrawer(event.detail || {});
  });

  document.addEventListener('sc:cart:add', function (event) {
    var detail = event.detail || {};
    addOrIncrement(detail)
      .then(function () {
        if (typeof detail.onDone === 'function') detail.onDone();
      })
      .catch(function (error) {
        if (typeof detail.onError === 'function') detail.onError(error);
      });
  });

  document.addEventListener('sc:cart:refresh', refresh);

  refresh();
})();
